import React, { useState } from 'react';
import { ShieldAlert, GitBranch, Package } from 'lucide-react';
import SecurityAlertsTab from './tabs/SecurityAlertsTab';
import ChangelogTab from './tabs/ChangelogTab';
import UpdatesTab from './tabs/UpdatesTab';
import { theme, rgba } from '../../theme';

const TABS = [
  { key: 'alerts', label: 'Security Alerts', icon: ShieldAlert, component: SecurityAlertsTab },
  { key: 'changelog', label: 'Changelog', icon: GitBranch, component: ChangelogTab },
  { key: 'updates', label: 'Updates', icon: Package, component: UpdatesTab },
];

const SecurityAlertsPanel = () => {
  const [activeTab, setActiveTab] = useState('alerts');
  const ActiveComponent = TABS.find((t) => t.key === activeTab)?.component || SecurityAlertsTab;

  return (
    <div style={{ padding: '24px', minHeight: '100vh', background: `linear-gradient(135deg, ${rgba(theme.colors.primaryRgb, 0.1)}, ${rgba(theme.colors.accentRgb, 0.1)})` }}>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px' }}>
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              padding: '10px 18px', borderRadius: '8px', cursor: 'pointer',
              border: activeTab === key ? '1px solid rgba(59,130,246,0.5)' : '1px solid rgba(148,163,184,0.2)',
              background: activeTab === key ? 'rgba(59,130,246,0.2)' : 'rgba(15,23,42,0.4)',
              color: activeTab === key ? '#3b82f6' : '#94a3b8',
              fontWeight: activeTab === key ? 600 : 400,
              transition: 'all 0.15s ease',
            }}
          >
            <Icon size={16} />
            {label}
          </button>
        ))}
      </div>

      <ActiveComponent />
    </div>
  );
};

export default SecurityAlertsPanel;
